import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from '../common/entity';
import { ExportType } from './export';

export interface ObsoleteExportConfiguration {
  name: string;
  id: string;
  default: boolean;
}

export interface DraggableItem<T> {
  value: string;
  index: number;
  field: T;
  id: number;
  key: string;
}

export class ExportConfiguration<T> extends CompanyEntity {
  name!: string;
  type: ExportType = ExportType.csv;
  filename!: string;

  default: boolean = false;

  mapping: Map<T, { value: string; index: number }> = new Map();

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    this.default = false;
    Object.assign(this, cloneDeep(obj));
    this.default = obj.default || false;

    if (this.mapping && !(this.mapping instanceof Map)) {
      this.mapping = new Map<T, { value: string; index: number }>(Object.entries(this.mapping) as any);
    }

    // Backward compatibility
    if (!this.mapping.size && (this as any).fieldMapping) {
      this.mapping = new Map(
        (this as any).fieldMapping.map((m: any) => [m.field, { value: m.customField, index: m.index }]),
      );
    }
  }

  static toDraggableItems<T>(item: ExportConfiguration<any>): DraggableItem<T>[] {
    return [...item.mapping.entries()].map((value: [T, { value: string; index: number }], index: number) => {
      return { value: value[1].value, index: value[1].index, field: value[0], id: index, key: `${value[0]}${index}` };
    });
  }

  withName(name: string) {
    this.name = name;
    return cloneDeep(this);
  }

  withFilename(filename: string) {
    this.filename = filename;
    return cloneDeep(this);
  }

  withDefault(value: boolean) {
    this.default = value;
    return cloneDeep(this);
  }

  withType(type: ExportType) {
    this.type = type;
    return cloneDeep(this);
  }
}
